import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    leftBlock: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      marginBottom: 15,
      [theme.breakpoints.up('md')]: {
        marginRight: 45,
        marginBottom: 0,
      },
    },
    lockIcon: {
      width: 24,
      height: 24,
      position: 'absolute',
      top: 28,
      left: 26,
      [theme.breakpoints.up('md')]: {
        position: 'relative',
        marginRight: '25px',
        width: 43,
        height: 43,
        top: 'unset',
        left: 'unset',
      },
    },
    lockText: {
      fontSize: 18,
      lineHeight: 1.2,
      marginBottom: 10,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        marginBottom: 10,
        width: 130,
      },
    },
    description: {
      flex: 4,
      color: colorsPalette.gray,
      fontSize: 16,
      lineHeight: 1.5,
      marginBottom: 15,
      [theme.breakpoints.up('md')]: {
        textAlign: 'left',
        fontSize: 18,
        marginRight: 90,
        marginLeft: 48,
        marginBottom: 0,
      },
    },
    link: {
      width: '100%',
      '& button': {
        width: '100%',
      },
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
        margin: '0 auto',
      },
      [theme.breakpoints.up('md')]: {
        margin: 0,
      },
    },
  }),
);

export default useStyles;
